<template>
    <!-- CTA final -->
    <section class="cta-wrap text-center">
        <div class="container py-5">
            <h3 class="fw-bold mb-2">¿Listo para tu propuesta?</h3>
            <p class="mb-4">Agendemos una llamada y te envio un plan con tiempos, entregables y precio claro.</p>
            <a :href="whatsLink()" target="_blank"
                class="btn btn-outline-light btn-lg bg-gradient-pill newsletter"
                @click="trackWhatsapp"
                >
                Hablar por WhatsApp
            </a>
        </div>
    </section>
</template>
<script setup>
const WHATS_NUMBER = '522281649497'

function whatsLink(paquete) {
  const txt = encodeURIComponent(`Hola, me interesa un desarrollo a la medida (paquete ${paquete || 'web'}). ¿Podemos cotizar?`)
  return `https://wa.me/${WHATS_NUMBER}?text=${txt}`
}

// 👉 Evento Google Analytics / Ads
function trackWhatsapp() {
  if (window.gtag) {
    window.gtag("event", "whatsapp_click", {
      event_category: "lead",
      event_label: "cta_principal_whatsapp",
      value: 1
    });
    // Google Ads – Conversión
    window.gtag("event", "conversion", {
      send_to: "AW-1016280589/RFY6COjOxocDEI3szOQD"
    });
  }
}
</script>

<style scoped>
.cta-wrap {
    background: linear-gradient(180deg, #0e2533, #0b1822);
    border-top: 1px solid rgba(255, 255, 255, .08);
}

.newsletter {
    font-size: 1.1rem;
}

.btn-outline-light {
    border-radius: 999px;
}
</style>